<template>
  <div class="date-input-wrapper" :class="{'error':error}">
    <flat-pickr id="effectiveDate" :placeholder="placeholder" v-model="date"
      :config="config" @input="changed" @on-open="$emit('focus')" @on-close="blur"></flat-pickr>
    <i class="material-icons warning">warning</i>
    <i class="material-icons calendar">event</i>
    <slot name="help-text"></slot>
    <slot name="errors"></slot>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'date-input',
  props: {
    value: {
      required: true
    },
    id: {
      type: String
    },
    name: {
      type: String
    },
    format: {
      type: String
    },
    effectiveOnRange: {
      type: Object
    },
    error: {
      type: Boolean
    },
    placeholder: {
      type: String
    }
  },
  data() {
    return {
      date: this.value
    }
  },
  computed: {
    config: {
      get: function () {
        let config = {
          altInput: true,
          altFormat: this.format
        };

        if (this.effectiveOnRange) {
          config.enable = [
            {
              from: this.effectiveOnRange.from,
              to: this.effectiveOnRange.to
            }
          ];
        }

        return config;
      }
    }
  },
  methods: {
    changed: function (val) {
      this.$emit('input', moment(val, 'YYYY-MM-DD').toDate());
    },
    blur: function (selectedDates, dateStr, instance) {
      // Fix for mobile safari: The element does not blur correctly and causes issues with
      // trying to click back in to change the date after selecting the date the first time.
      let datePickerInstances = document.querySelectorAll('.flatpickr-input.form-control');
      for (var i = 0; i < datePickerInstances.length; i++) {
        datePickerInstances[i].blur();
      }
    }
  }
}
</script>

<style lang="scss">
.flatpickr-months {
  .numInputWrapper:hover {
    background: transparent;

    span {
      opacity: 0;
    }
  }
}

.flatpickr-rContainer {
  max-width: 100%;
}

.date-input-wrapper {
  .material-icons.calendar {
    pointer-events: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/forms/date-input.vue